export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8133.2490b414.jpg";